const Status = Object.freeze([
    { value: 1, label: 'Pending' },
	{ value: 2, label: 'Blocked' },
    { value: 3, label: 'Active' },
    { value: 4, label: 'Incomplete' },
    { value: 5, label: 'Rejected' },
])

export default Status;